import {KTSVG} from '_metronic/helpers'
import React from 'react'

interface Props {
  onClick: () => void
}

export const CustomRateButton: React.FC<Props> = ({onClick}) => {
  return (
    <button className='btn explore-btn-outline text-primary-active w-100' onClick={onClick}>
      <KTSVG
        path='/media/icons/duotune/arrows/arr075.svg'
        className='svg-icon-3 svg-icon-primary-active'
      />
      Enter In Custom Rate
    </button>
  )
}

export default CustomRateButton
